import React from 'react';
import Spa16 from 'dc/Spa16';
import TransportSVG from 'dc/TransportSVG';
import EnergySVG from 'dc/EnergySVG';
import { CATEGORY, ICON } from 'resources/constants';

import {
  OuterWrapper,
  ImageContainer,
  InfoWrapper,
  TranslateTitle,
  MainText,
  SubText,
  PlaceholderWrapper,
  Loader,
} from './elements';
import PlaHo01 from 'dc/PlaHo01';
import { Typ20 } from 'dc/Typ';

type Props = {
  readonly className?: string;
  readonly placeholder?: boolean;
  readonly placeholderText?: string;
  readonly loader?: React.ReactNode;
  readonly loaderText?: string;
  readonly title?: string;
  readonly mainText: string;
  readonly subText: string;
  readonly translate: {
    category: string;
    backgroundColor: string;
    vehicle: string;
    from: string;
    to: string;
    appliance: string;
    quantity: string;
    units: string;
  };
  readonly translateImageUrl: string;
};

export default function TranslateContainer({
  className,
  placeholder,
  placeholderText,
  loader,
  loaderText,
  title,
  mainText,
  subText,
  translate,
  translateImageUrl,
}: Props): React.ReactElement {
  function renderImage() {
    if (translate.category === CATEGORY.transport) {
      return (
        <TransportSVG
          translateImageUrl={translateImageUrl}
          backgroundColor={translate.backgroundColor}
          vehicle={translate.vehicle}
          from={translate.from}
          to={translate.to}
        />
      );
    } else if (translate.category === CATEGORY.energy) {
      return (
        <EnergySVG
          translateImageUrl={translateImageUrl}
          backgroundColor={translate.backgroundColor}
          appliance={translate.appliance}
          quantity={translate.quantity}
          units={translate.units}
        />
      );
    }

    return null;
  }

  if (placeholder) {
    return (
      <PlaceholderWrapper>
        <PlaHo01 icon={ICON.leaf} text={placeholderText} />
      </PlaceholderWrapper>
    );
  }

  if (loader) {
    return (
      <Loader>
        <Typ20>{loaderText}</Typ20>
      </Loader>
    );
  }

  return (
    <OuterWrapper className={className}>
      <ImageContainer>{renderImage()}</ImageContainer>
      <InfoWrapper>
        <TranslateTitle>{title}</TranslateTitle>
        <Spa16 />
        <MainText>{mainText}</MainText>
        <Spa16 />
        <SubText>{subText}</SubText>
      </InfoWrapper>
    </OuterWrapper>
  );
}
